import { CourseType, CourseTypes } from "../../../DTOs";
import { basicValidation } from "../basicValidation";
import { fieldValidation } from "../fieldValidation";

export const courseFieldValidation = {
    course: {
        id: (value: string) =>  basicValidation.resourceId.isValid(value),
        provider: (value: string) =>  basicValidation.resourceText.isValid(value, false, 100),
        type: (type: CourseType) => {
            return CourseTypes.find(ct => ct === type) !== undefined;
        },
        title: (value: string) =>  basicValidation.resourceText.isValid(value, false, 100),
        description: (value: string) =>  basicValidation.resourceText.isValid(value, true, 1000),
        days: (dts: Date[]) => {
            if (dts === null || dts === undefined || !Array.isArray(dts) || dts.length === 0 || dts.length > 10)
                return false;
            if (dts.find(dt => !basicValidation.date(dt)))
                return false;
            return true;
        },
        signupDeadline: (dt: Date) => {
            return basicValidation.date(dt);
        },
        location: (value: string) =>  basicValidation.resourceText.isValid(value, false, 100),
        contactUrl: (value: string) => basicValidation.isValidUrl(value, true, 500),
        contactEmail: (value: string) => basicValidation.isValidEmail(value, true),
        contactPhone: (value: string) => basicValidation.isValidPhoneNumber(value, false)
    },

    userCourse: {
        id: (value: string) =>  basicValidation.resourceId.isValid(value),
        provider: (value: string) =>  basicValidation.resourceText.isValid(value, false, 100),
        type: (type: CourseType) => fieldValidation.course.type(type),
        title: (value: string) =>  basicValidation.resourceText.isValid(value, false, 100),
        description: (value: string) =>  basicValidation.resourceText.isValid(value, true, 1000),
        completedDate: (value: Date) => basicValidation.date(value)
    },
};